import {Popover} from "@blueprintjs/core";
import styled from "@emotion/styled";
import {useState} from "react";
import {PremiumBadge} from "./ETANotificationConfigs.style";
import {PremiumStarIcon} from "../../../../common/icons";
import {COLORS, Constants} from "../../../../../constants/constants";

export const PremiumUpgradePopover = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleRequestConsult = () => {
    window.open(Constants.ETA_PREMIUM_CONSULT_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <Popover
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      placement="right"
      content={
        <PopoverContent>
          <PopoverHeader>
            <PremiumStarIcon size={24} />
            <PopoverTitle>Request a Consult</PopoverTitle>
          </PopoverHeader>
          <PopoverDescription>
            If you&apos;re interested in sending these notifications via a higher cost approach of text, or to send 2
            notifications per stop, please request a consult.
          </PopoverDescription>
          <RequestConsultButton onClick={handleRequestConsult}>Request Consult</RequestConsultButton>
        </PopoverContent>
      }
    >
      <PremiumBadge className="premium-badge" onClick={() => setIsOpen(!isOpen)}>
        Get Premium
      </PremiumBadge>
    </Popover>
  );
};

const PopoverContent = styled.div`
  font-family: Roboto, sans-serif;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  max-width: 330px;
  border-radius: 12px;
`;

const PopoverHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const PopoverTitle = styled.span`
  margin-top: 4px;
  line-height: 16px;
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.TEXT_BLACK};
`;

const PopoverDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: ${COLORS.TEXT_GRAY_MEDIUM};
  margin: 0;
`;

const RequestConsultButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  background: ${COLORS.BG_GRADIENT_DARK_BLUE};
  color: #fff;
  border: none;
  border-radius: 12px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 4px;

  &:hover {
    opacity: 0.9;
  }
`;
